import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, r = /* @__PURE__ */ t("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 6v12m-6-6h12m4.8 0c0 5.965-4.835 10.8-10.8 10.8-5.964 0-10.8-4.835-10.8-10.8S6.036 1.2 12 1.2 22.8 6.035 22.8 12"
}, null, -1), c = [
  r
];
function s(l, i) {
  return e(), o("svg", n, [...c]);
}
const h = { render: s };
export {
  h as default,
  s as render
};
